import { Metric } from 'web-vitals';

const vitalsUrl = 'https://vitals.vercel-analytics.com/v1/vitals';

// Network Information API isn't in lib.dom yet.
type NavigatorWithConnection = Navigator & {
  connection?: { effectiveType?: string };
};

function getConnectionSpeed(): string {
  const { connection } = navigator as NavigatorWithConnection;
  return connection?.effectiveType ?? '';
}

export function sendToVercelAnalytics(metric: Metric) {
  const analyticsId = process.env.REACT_APP_VERCEL_ANALYTICS_ID;
  if (!analyticsId) {
    return;
  }

  const body = {
    dsn: analyticsId,
    id: metric.id,
    page: window.location.pathname,
    // Origin + path only: query strings and fragments can carry tokens.
    href: window.location.origin + window.location.pathname,
    event_name: metric.name,
    value: metric.value.toString(),
    speed: getConnectionSpeed(),
  };

  const blob = new Blob([new URLSearchParams(body).toString()], {
    // This content type is necessary for `sendBeacon`
    type: 'application/x-www-form-urlencoded',
  });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(vitalsUrl, blob);
  } else
    fetch(vitalsUrl, {
      body: blob,
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
    });
}
